// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1G76v","approved":"Status_approved__3iY6a","rejected":"Status_rejected__3PA2T","expired":"Status_expired__5wcsp","label":"Status_label__1SC4e"};